
import { Component, Vue, Prop } from 'vue-property-decorator';
import { iSelectOptionsList } from '@/interface/cancel-detail';
@Component
export default class extends Vue {
  @Prop() shortcut!: iSelectOptionsList;
  @Prop() activeIndex!: number;
  @Prop() initDay!: number;
  @Prop() defaultDays!: { day: number; initDay: number };
  @Prop({ default: false }) isToDay!: boolean;
  /* days: 天数
  activeIndex： 选中状态
  isToDay: 是否包含当天
   */
  getTimeFn(days: number, activeIndex: number, isToDay: boolean) {
    if (days == 0) {
      // 统计数据不包含当天
      return;
    }

    let params = { start: 0, end: 0 };
    let dates: (string | Date)[] = [];

    const end = new Date();
    const start = new Date();
    if (!isToDay) {
      // 统计数据不包含当天
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
    }
    start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
    dates = [start, end]; // 默认
    params.start = Math.round(new Date(this.formatDate(start) + ' 00:00:00').getTime() / 1000);
    params.end = Math.round(new Date(this.formatDate(end) + ' 23:59:59').getTime() / 1000);
    if (days == 1) {
      // 昨天
      dates = [start, start];
      params.end = Math.round(new Date(this.formatDate(start) + ' 23:59:59').getTime() / 1000);
    }
    this.$emit('getTimeFn', dates, params, activeIndex);
  }
  /**
   * 格式化时间
   */
  formatDate(date: Date) {
    let myyear: string | number = date.getFullYear();
    let mymonth: string | number = date.getMonth() + 1;
    let myweekday: string | number = date.getDate();

    if (mymonth < 10) {
      mymonth = '0' + mymonth;
    }
    if (myweekday < 10) {
      myweekday = '0' + myweekday;
    }
    return myyear + '/' + mymonth + '/' + myweekday;
  }
  mounted() {
    if (this.activeIndex === this.initDay) {
      this.getTimeFn(this.defaultDays.day, this.defaultDays.initDay, false);
    }
  }
}
